import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers } from 'recompose';
import Select from 'react-select';
import { List } from 'immutable';

import formControl from '../formControl';
import * as styles from '../styles.css';
import { useTranslation } from 'react-i18next';

export const optionsForGet = [
  { value: 'M', label: 'Man' },
  { value: 'F', label: 'Kvinna' },
  { value: 'X', label: 'Ickebinär' },
  { value: 'null', label: 'Okänt' },
];

export const optionsForPost = [
  { value: 'M', label: 'Man' },
  { value: 'F', label: 'Kvinna' },
  { value: 'X', label: 'Ickebinär' },
  { value: '', label: 'Okänt' },
];

function ResourceSexSelect({
  input, onChange, multi, disabled, isEditable, clearable, options = optionsForPost,
}) {
  const { t } = useTranslation();
  if (!isEditable && !multi) {
    const option = options.find(({ value }) => value === input.value);
    const label = option ? option.label : 'Kön...';
    return <div className={styles.value}>{label}</div>;
  }

  return (
    <div style={{ width: '100%' }} data-testid="ResourceSexSelect">
      <Select
        name={input.name}
        placeholder={t("Kön")}
        options={options}
        value={List.isList(input.value) ? input.value.toJS() : input.value}
        onChange={onChange}
        multi={multi}
        disabled={disabled}
        clearable={clearable}
      />
    </div>
  );
}

ResourceSexSelect.defaultProps = {
  input: {
    name: 'gender',
    value: undefined,
  },
  multi: false,
  disabled: false,
  clearable: true,
  isEditable: true,
};

ResourceSexSelect.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(List), PropTypes.number]),
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  multi: PropTypes.bool,
  disabled: PropTypes.bool,
  isEditable: PropTypes.bool,
  clearable: PropTypes.bool,
  options: PropTypes.object
};

export default compose(
  formControl,
  withHandlers({
    onChange: ({ input, multi }) => (value) => {
      if (!multi) {
        if (value) {
          input.onChange(value.value);
        } else {
          input.onChange(value);
        }
        return;
      }

      if (!value) {
        input.onChange(new List());
        return;
      }
      input.onChange(new List(value));
    },
  }),
)(ResourceSexSelect);
